import PropTypes from 'prop-types';
import { Box } from '@nfs/ui-kit';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const InlineError = ({ message }) => (
    <Box component="span" display="flex" alignItems="center">
        <ErrorOutlineIcon />
        <Box component="span" ml={1}>
            {message}
        </Box>
    </Box>
);

InlineError.propTypes = {
    message: PropTypes.string.isRequired
};

export default InlineError;
